"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _isNil2 = _interopRequireDefault(require("lodash/isNil"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var Cccisd = window.cccisd;

/*
 * Example for this renderer:
 *   One of the objects in the array at location window.cccisd.appDefs.pawn.fields:
 *   {
 *       "handle": "grade",
 *       "label": "Grade",
 *       "data_type": "enum",
 *       "values": [
 *           {
 *               "name": "3",
 *               "value": "3"
 *           },
 *           {
 *               "name": "4",
 *               "value": "4"
 *           },
 *           {
 *               "name": "5",
 *               "value": "5"
 *           },
 *           {
 *               "name": "6",
 *               "value": "6"
 *           },
 *           {
 *               "name": "7",
 *               "value": "7"
 *           }
 *       ]
 *   }
 *
 *   In the column definition:
 *   "renderAs": {
 *       "type": "AppdefsEnum",
 *       "class": "html",
 *       "settings": {
 *           "appdefsEnum": [
 *               {
 *                   "path": "pawn.fields",
 *                   "arrayKey": "handle",
 *                   "arrayValueAtKey": "grade"
 *               },
 *               {
 *                   "path": "values"
 *               }
 *           ],
 *           "labelKey": "name",
 *           "valueKey: "value"
 *       }
 *   }
 *
 *   Example where values are object keys (`"objectKeyValues" = true`):
 *   window.cccisd.appDefs.assignments:
 *   {
 *       "main": {
 *           "handle": "Main Assessment"
 *           ...
 *       },
 *       "teacher": {
 *           "handle": "Teacher Assessment",
 *           ...
 *       }
 *   }
 *
 *   In the column definition:
 *   "renderAs": {
 *       "type": "AppdefsEnum",
 *       "class": "html",
 *       "settings": {
 *           "appdefsEnum": [
 *               {
 *                   "path": "assignments",
 *               }
 *           ],
 *           "labelKey": "label",
 *           "objectKeyValues": true
 *       }
 *   }
 *
 */
var _default = exports["default"] = function _default(settings) {
  return function (_ref) {
    var value = _ref.value,
      row = _ref.row;
    var noValue = false;
    var displayValue = '';
    if ((0, _isNil2["default"])(value)) {
      noValue = true;
    } else {
      displayValue = value.toString();
    }
    settings.prefix = settings.prefix ? settings.prefix : '';
    settings.suffix = settings.suffix ? settings.suffix : '';
    var enumOptions = Cccisd;
    if (enumOptions) {
      enumOptions = settings.basePath ? enumOptions[settings.basePath] : enumOptions.appDefs;
    }
    if (enumOptions) {
      // Chain into appDefs to locate enum
      settings.appdefsEnum.forEach(function (chain) {
        if (chain.path) {
          enumOptions = (0, _get2["default"])(enumOptions, chain.path);
        }
        if (chain.arrayKey && chain.arrayValueAtKey && enumOptions) {
          enumOptions = enumOptions.find(function (e) {
            return e[chain.arrayKey] === chain.arrayValueAtKey;
          });
        }
      });
      if (Array.isArray(enumOptions)) {
        var labelKey = settings.labelKey ? settings.labelKey : 'name';
        var valueKey = settings.valueKey ? settings.valueKey : 'value';
        for (var i = 0; i < enumOptions.length; i++) {
          var option = enumOptions[i];
          if (option[valueKey] === value) {
            displayValue = option[labelKey].toString();
            noValue = false;
            break;
          }
        }
      } else if (enumOptions && _typeof(enumOptions) === 'object' && settings.objectKeyValues) {
        var _labelKey = settings.labelKey ? settings.labelKey : 'name';
        // The object keys are the values in this case
        var enumOptionsValues = Object.keys(enumOptions);
        for (var _i = 0; _i < enumOptionsValues.length; _i++) {
          var optionValue = enumOptionsValues[_i];
          if (optionValue === value) {
            // To get to the labelKey, we must chain into the
            // enumOptions object with the identified key
            displayValue = enumOptions[optionValue][_labelKey].toString();
            noValue = false;
            break;
          }
        }
      }
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: row
    }, !noValue ? /*#__PURE__*/_react["default"].createElement("div", null, "".concat(settings.prefix).concat(displayValue).concat(settings.suffix)) : /*#__PURE__*/_react["default"].createElement("div", null));
  };
};